import { createPopper } from "@popperjs/core";

export default class SelectTag {
  constructor(node) {
    this.element = node;

    this.selectBtn = this.element.querySelector(".js-select-button");
    this.selectedValue = this.element.querySelector(".js-selected-value");
    this.inputField = this.element.querySelector(".js-select-input");
    this.inputElement = this.element.querySelector(".js-select-hidden-input");
    this.dropdownElement = this.element.querySelector(".js-select-dropdown");

    this.initialized = false; // We need to let region_select.js querySelector the dropdown element before we remove it from the DOM.
    this.dropdownVisible = false;
    this.boundFunction = this.checkIfWithinBounds.bind(this);
    this.timeout;

    this.initialize();
  }

  initialize() {
    this.selectBtn.addEventListener("click", () => {
      if (!this.initialized) {
        this.initialized = true;
        this.dropdownElement.remove();
        this.dropdownElement.classList.remove("d-none");
      }

      this.toggleDropdown();
    });

    this.dropdownElement.addEventListener("click", (e) => {
      if (e.target.tagName !== "LABEL") {
        return;
      }

      this.handleSelectTagClick(e);
    });
  }

  handleSelectTagClick(e) {
    const { target } = e;

    const selectValue = target.querySelector(".js-select-value");
    const input = target.querySelector("input");

    if (selectValue) {
      Object.keys(input.dataset).forEach((key) => {
        this.inputElement.dataset[key] = input.dataset[key];
      });

      this.selectedValue.innerHTML = selectValue.innerHTML;
      this.inputElement.value = input.value;
      this.inputElement.dispatchEvent(new Event("change"));
      input.checked = true;
      input.dispatchEvent(new Event("change"));
    }

    this.toggleDropdown();
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
    this.selectBtn.setAttribute("aria-expanded", this.selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true");

    if (this.inputField) {
      const event = new Event("select-dropdown-toggled");
      this.inputField.dispatchEvent(event);
    }

    if (this.dropdownVisible) {
      document.body.appendChild(this.dropdownElement);
      this.setDropdownPosition();
      document.addEventListener("click", this.boundFunction);
    } else {
      document.removeEventListener("click", this.boundFunction);
      this.dropdownElement.remove();
    }
  }

  setDropdownPosition() {
    this.popper = createPopper(this.selectBtn, this.dropdownElement, {
      placement: "bottom-start",
      modifiers: [
        {
          name: "sameWidth",
          enabled: true,
          fn: ({ state }) => {
            state.styles.popper.width = `${state.rects.reference.width}px`;
          },
          phase: "beforeWrite",
          requires: ["computeStyles"],
        },
        {
          name: "flip",
          options: {
            padding: {
              top: 16,
            },
          },
        },
        {
          name: "offset",
          options: {
            offset: [0, 16],
          },
        },
      ],
    });
  }

  checkIfWithinBounds(e) {
    const target = e.target;

    if (this.dropdownElement == target) {
      return;
    }

    if (!this.dropdownElement.contains(target)) {
      if (!this.element.contains(target)) {
        this.toggleDropdown();
      }
    }
  }
}
